const INITIAL_STATE = {
  // app state
  hasError: false,
  errorText: "",
  isLoading: false,
  loadingText: "",
  selectedTabId: "db4_mailer",
  clientGroups: [],
  practitioners: [],
  admins: [],
  nurses: [],
  supervisors: [],
  referrers: [],
  locations: [],
  clinics: [],

  // db4 state
  db4: {
    selectedAppointmentId: "",
    appointments: {},
    appointmentList: {},
    db4Notification: {},
    appointmentToPatientNotification: {},
    appointmentToDoctorNotification: {},
  },

  // workflow state
  workflow: {
    patients: {},
    patientList: {},
    selectedPatientId: "",
    trackedPatients: {},
  },
};

export default INITIAL_STATE;
